// packages block
import { InputAdornment, TextField } from '@mui/material'
import { FC, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
// styles, constants, utils and interfaces block
import { PASSWORD, TEXT } from '../../constants'
import { CustomControlProps, PasswordType } from '../../interfaceTypes'
import { ShowPassword } from './ShowPassword'

export const CustomController: FC<CustomControlProps> = ({
  controllerName,
  controllerLabel,
  fieldType,
  isDisabled,
  isMultiLine,
  maxLength,
  rowsLength,
  readOnly,
  defaultValue,
  isShrink,
  isPassword,
  upperCase,
  dollarAdornment,
  sx,
  placeholder,
  onBlur,
  onKeyDown,
  required = false,
  fullWidth = true,
  startAdornment,
  autoFocus,
  min,
  max,
  size,
  setParams
}): JSX.Element => {
  const { control } = useFormContext()
  const [passwordType, setPasswordType] = useState<PasswordType>(PASSWORD)

  const handleClickShowPassword = () => {
    if (passwordType === PASSWORD) {
      setPasswordType(TEXT)
    } else {
      setPasswordType(PASSWORD)
    }
  }

  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field, fieldState: { invalid, error: { message } = {} } }) => (
        <TextField
          type={fieldType === 'password' ? passwordType : fieldType}
          margin="dense"
          error={invalid}
          defaultValue={defaultValue}
          label={controllerLabel}
          disabled={isDisabled}
          rows={isMultiLine ? rowsLength : undefined}
          fullWidth={fullWidth}
          {...field}
          helperText={message}
          multiline={isMultiLine}
          placeholder={placeholder}
          onBlur={event => onBlur && onBlur(event)}
          onKeyDown={event => onKeyDown && onKeyDown(event)}
          size={size}
          onChange={event => {
            field.onChange(event)
            if (setParams) {
              setParams(event.target.value, controllerName)
            }
          }}
          required={required}
          variant="outlined"
          InputLabelProps={{ shrink: isShrink || fieldType === 'date' || !!field.value ? true : undefined }}
          inputProps={{
            style: {
              textTransform: upperCase ? 'uppercase' : 'inherit'
            },
            maxLength: maxLength || undefined,
            readOnly,
            autoFocus,
            onWheel: fieldType === 'number' ? e => e.currentTarget?.blur() : undefined
          }}
          InputProps={{
            startAdornment: dollarAdornment ? <InputAdornment position="start">$</InputAdornment> : startAdornment,
            endAdornment: [
              isPassword ? (
                <ShowPassword
                  isPassword={isPassword}
                  passwordType={passwordType}
                  handleShowPassword={handleClickShowPassword}
                />
              ) : null
            ]
          }}
          sx={{
            ...sx
          }}
        />
      )}
    />
  )
}
